<app-header [heading]="'CREDITS.HEADER.TITLE' | translate"></app-header>
<div class="credit-page-wrapper">
  <div class="main-content">
    <div class="left-column">
      @if ((client?.credits?.length ?? 0) > 0) {
        <app-credit-summary></app-credit-summary>
      }
      <app-credit-history></app-credit-history>
      <app-credit-transfers></app-credit-transfers>
    </div>

    <div class="right-column">
      <app-payment-methods></app-payment-methods>
    </div>
  </div>
</div>
